import axios from 'axios';
import qs from 'qs';

/**
 * 常用工具类
 * **/
var TYBM_Tools = (function () {

    /**
     * 获取url中的参数
     * @param {any} name  参数名
     */
    function GetUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) return decodeURI(r[2]); return null; //返回参数值
    }

    /**
     * 从列表中移除元素
     * @param {any} list
     * @param {any} item
     * 返回删除结果，已删除为true，不存在为false
     */
    function RemoveItem(list, item) {
        var index = list.indexOf(item);
        if (index >= 0) {
            list.splice(index, 1);
            return true;
        }
        return false;
    }

    function FormatDate(fmt, date) {
        var ret;
        const opt = {
            "y+": date.getFullYear().toString(),        // 年
            "M+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "m+": date.getMinutes().toString(),         // 分
            "s+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (var k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
        }
        return fmt;
    }

    function BuildAxiosPostOptions(apiPath, data) {
        return {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: apiPath
        }

    }
    function AppendPageInfo(url, pageIdx, pageCount) {
        var prefix = url.indexOf('?') >= 0 ? '&' : '?';
        if (pageIdx) {
            url += prefix + "Page=" + pageIdx;
            prefix = '&';
        }
        if (pageCount) {
            url += prefix + "PageCount=" + pageCount;
        }
        return url;
    }

    function AxiosPost(apiPath, data) {
        return axios(BuildAxiosPostOptions(apiPath, data));
    }

    function AxiosGet(apiPath) {
        return axios.get(apiPath);
    }

    /**
     * 附加处理进度
     * @param {any} that
     * @param {any} options
     * @param {any} axios_option
     */
    function AttachProgress(that, options, axios_option) {

        axios_option.onDownloadProgress = function (event) {

            if (options.loading_msg && typeof (that.Loading) === "function") {
                var progress = Math.ceil(event.loaded * 10000.0 / (event.total - 500)) / 100.0;
                if (progress > 100) {
                    progress = 100;
                }
                that.Loading(options.loading_msg + '（当前进度：' + progress + '%）');
            }
        };
        axios_option.transformResponse = [function (data) {

            var ret = '';
            for (var i = 0; i < data.length; i++) {
                if (data.charCodeAt(i) == 0) {
                    continue;
                }
                ret += data.charAt(i);
            }
            return JSON.parse(ret);
        }]
    }

    /**
     * 返回Axios Promise结构
     * @param {any} that
     * @param {any} api_name
     * @param {any} options
     * @param {any} axios_option
     * @param {any} method_name
     */
    function AxiosEx(that, api_name, options, axios_option, method_name) {

        return new Promise(function (resolve, reject) {
            axios(axios_option).then(response => {
                window.console.log(method_name, api_name, response);

                if (options.loading_msg && typeof (that.LoadingCompleted) === "function") {
                    that.LoadingCompleted();
                }

                var result = response.data;
                if (result.code == 'ok') {
                    resolve(result);
                } else {
                    if (!options.hide_tip) {
                        TYBM_Tools.ProcessApiError(that, api_name, result);
                    }
                    reject(result);
                }
            }).catch(error => {

                if (options.loading_msg && typeof (that.LoadingCompleted) === "function") {
                    that.LoadingCompleted();
                }

                if (!options.hide_tip) {
                    TYBM_Tools.ProcessCatchError(that, api_name, error);
                }
                reject({ code: 'error', data: error });
            });
        });
    }


    function AxiosPostEx(that, api_name, apiPath, data, options) {

        window.console.log("Http Post:", apiPath, data);

        if (options.loading_msg && typeof (that.Loading) === "function") {
            that.Loading(options.loading_msg);
        }

        var axios_option = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: apiPath,
        }

        if (options.has_progress) {
            // 如果设置了报告进度
            AttachProgress(that, options, axios_option);
        }

        return AxiosEx(that, api_name, options, axios_option, "Http Post:");
    }

    function AxiosGetEx(that, api_name, apiPath, options) {

        window.console.log("Http Get:", apiPath);

        if (options.loading_msg && typeof (that.Loading) === "function") {
            that.Loading(options.loading_msg);
        }

        var axios_option = {
            method: 'GET',
            url: apiPath,
        }

        if (options.has_progress) {
            // 如果设置了报告进度
            AttachProgress(that, options, axios_option);
        }

        return AxiosEx(that, api_name, options, axios_option, "Http Get:");
    }

    /**
     * 上传文件
     * @param {any} that
     * @param {any} api_name
     * @param {any} apiPath
     * @param {any} data  data中包含文件名称
     * @param {any} options
     */
    function AxiosUploadFile(that, api_name, apiPath, data, options) {

        window.console.log("File Upload:", apiPath, data);

        var formData = new FormData();
        // 文件列表
        for (var field_name in data) {
            formData.append(field_name, data[field_name]);
        }

        if (options.loading_msg && typeof (that.Loading) === "function") {
            that.Loading(options.loading_msg);
        }

        var axios_option = {
            method: 'POST',
            //headers: { 'content-type': 'multipart/form-data' },
            url: apiPath,
            data: formData,
            timeout: 300000, // 增加超时时间到2分钟
            onUploadProgress: function (event) {

                if (options.loading_msg && typeof (that.Loading) === "function") {
                    var progress = Math.ceil(event.loaded * 10000.0 / event.total) / 100.0;
                    if (progress >= 100) {
                        that.Loading(options.loading_msg + '（文件已上传完毕）');
                    } else {
                        that.Loading(options.loading_msg + '（文件上传：' + progress + '%）');
                    }
                }
            }
        }

        if (options.has_progress) {
            // 如果设置了报告进度
            AttachProgress(that, options, axios_option);
        }

        return AxiosEx(that, api_name, options, axios_option, "File Upload:");
    }

    function ProcessApiError(that, api_name, result) {
        window.console.log(api_name + ' error', result.errmsg);
        //that.$message({
        //    type: 'error',
        //    message: result.errmsg,
        //    title: '温馨提示'
        //});
        that.$alert(result.errmsg, '温馨提示', {
            dangerouslyUseHTMLString: true
        });
    }

    function ProcessCatchError(that, api_name, error) {        
        window.console.log(api_name + ' error!', error);

        that.$alert(error, '温馨提示', {
            dangerouslyUseHTMLString: true
        });
        //that.$message({
        //    type: 'error',
        //    message: error,
        //    title: '温馨提示'
        //});
    }

    /**
     * 处理生成报表的结果
     * @param {any} that
     * @param {any} result
     * @param {any} title
     */
    function ProcessBaoBiaoResult(that, result, title) {

        if (result.data && result.data.DownloadUrl) {
            window.open(result.data.DownloadUrl, '_blank');
            that.$alert(`${title}已生成完毕，并自动下载，如果没有自动下载，请<a href="${result.data.DownloadUrl}" target="_blank">点击此处下载</a>`, '温馨提示', { dangerouslyUseHTMLString: true, });
        } else {

            that.$alert(result.data.Message || (title + '生成失败，未返回下载链接。'), '温馨提示', {
                dangerouslyUseHTMLString: true
            });
        }
    }

    return {
        GetUrlParam: GetUrlParam,
        RemoveItem: RemoveItem,
        FormatDate: FormatDate,
        BuildAxiosPostOptions: BuildAxiosPostOptions,
        AxiosPost: AxiosPost,
        AxiosPostEx: AxiosPostEx,
        AxiosGet: AxiosGet,
        AxiosGetEx: AxiosGetEx,
        AxiosUploadFile: AxiosUploadFile,
        ProcessApiError: ProcessApiError,
        ProcessCatchError: ProcessCatchError,
        AppendPageInfo: AppendPageInfo,
        ProcessBaoBiaoResult: ProcessBaoBiaoResult
    }
})();

export { TYBM_Tools };
